var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list" },
    [
      _c("div", { staticClass: "info-div" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v(
            _vm._s(
              _vm.$t("__.Crud.movimentacaoestoque.list_vue_html.movimentaEstq")
            )
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "info-panel" }, [
            _c("span", [_vm._v(_vm._s(_vm.total))]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.tituloPesquisa))]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "__.Crud.movimentacaoestoque.list_vue_html.cadastradas"
                  )
                )
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "grid-component",
        {
          ref: "gridcomponent",
          attrs: {
            columns: _vm.gridColumns,
            data: _vm.gridData,
            "page-index": _vm.pageIndex,
            "page-size": _vm.pageSize,
            "show-remove-item": false,
            startFilterKey: _vm.startFilterKey,
            tituloPagina: "Movimentações de Estoque",
            total: _vm.total,
          },
          on: {
            "change-filter-key": _vm.onChangeFilterKey,
            "change-page": _vm.onChangePage,
            "change-sort": _vm.onChangeSort,
            "create-item": _vm.onCreateItem,
            "edit-item": _vm.onEditItem,
            "gerar-impressao": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 2
            },
            "gerar-pdf": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 1
            },
            "gerar-xls": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 0
            },
          },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("div", { staticClass: "flex-row" }, [
              _c(
                "div",
                [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.$t("__.ts.buscarEm"))),
                  ]),
                  _vm._v(" "),
                  _c("combo-component", {
                    staticStyle: { width: "220px" },
                    attrs: {
                      data: _vm.tipoBuscaMovimentacaoOptions,
                      searchable: true,
                    },
                    model: {
                      value: _vm.tipoBuscaMovimentacao,
                      callback: function ($$v) {
                        _vm.tipoBuscaMovimentacao = $$v
                      },
                      expression: "tipoBuscaMovimentacao",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "filtro-lista" }, [
                _c(
                  "button",
                  {
                    staticClass: "filtro-avancado-button",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.unfoldedFilter = !_vm.unfoldedFilter
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("__.Crud.filtroAvancado")) +
                        "\n                        "
                    ),
                    _c("i", { staticClass: "fa fa-caret-down" }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.unfoldedFilter,
                        expression: "unfoldedFilter",
                      },
                    ],
                    staticClass: "drop-lista",
                  },
                  [
                    _c(
                      "form",
                      {
                        attrs: { novalidate: "novalidate" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.load($event)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "radio-group",
                            staticStyle: { "margin-bottom": "15px" },
                          },
                          [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.movimentacaoestoque.list_vue_html.dataInicial"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("date-time-picker-component", {
                              model: {
                                value: _vm.dataInicial,
                                callback: function ($$v) {
                                  _vm.dataInicial = $$v
                                },
                                expression: "dataInicial",
                              },
                            }),
                            _vm._v(" "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.movimentacaoestoque.list_vue_html.dataFinal"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("date-time-picker-component", {
                              model: {
                                value: _vm.dataFinal,
                                callback: function ($$v) {
                                  _vm.dataFinal = $$v
                                },
                                expression: "dataFinal",
                              },
                            }),
                            _vm._v(" "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.movimentacaoestoque.list_vue_html.tipoMov"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("combo-component", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              staticStyle: { background: "white" },
                              attrs: {
                                id: "tipoMovimentacaoId",
                                name: "tipoMovimentacaoId",
                                data: _vm.tiposMovimentosOptions,
                                searchable: true,
                              },
                              model: {
                                value: _vm.tipoMovimentoFiltro,
                                callback: function ($$v) {
                                  _vm.tipoMovimentoFiltro = $$v
                                },
                                expression: "tipoMovimentoFiltro",
                              },
                            }),
                            _vm._v(" "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.movimentacaoestoque.list_vue_html.estoque"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("combo-component", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              staticStyle: { background: "white" },
                              attrs: {
                                id: "estoqueId",
                                name: "estoqueId",
                                data: _vm.estoquesOptions,
                                searchable: true,
                              },
                              model: {
                                value: _vm.estoqueFiltro,
                                callback: function ($$v) {
                                  _vm.estoqueFiltro = $$v
                                },
                                expression: "estoqueFiltro",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "botao-filtrar",
                              attrs: { type: "submit" },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("__.Crud.filtrar")) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }